import React from 'react';
import GeckoDate from 'services/gecko-date';
import GeckoTableCellBase from '../_base.jsx';

class GeckoTableCellDate extends GeckoTableCellBase {
  render() {
    return (
      <div>
        {this.renderValue()
          ? new GeckoDate(this.renderValue()).format(
              this.props.col.format || 'MMM Do YYYY [at] HH:mm'
            )
          : null}
      </div>
    );
  }
}

export default GeckoTableCellDate;
